import { render, staticRenderFns } from "./cdn-button.vue?vue&type=template&id=47c29d13&scoped=true&"
import script from "./cdn-button.vue?vue&type=script&lang=js&"
export * from "./cdn-button.vue?vue&type=script&lang=js&"
import style0 from "./cdn-button.vue?vue&type=style&index=0&id=47c29d13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c29d13",
  null
  
)

export default component.exports